<template>
  <div class="custom-tooltip">
    <slot></slot>
    <div v-show="showTooltip" class="tooltip">
      <div class="tooltip-arrow"></div>
      <div class="tooltip-content">
        {{ text }}
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';

export default {
  props: {
    text: String,
  },
  setup(props) {
    const showTooltip = ref(false);

    const show = () => {
      showTooltip.value = true;
    };

    const hide = () => {
      showTooltip.value = false;
    };

    return {
      showTooltip,
      show,
      hide,
    };
  },
};
</script>

<style scoped>
.custom-tooltip {
  position: relative;
  display: inline-block;
}

.tooltip {
  position: absolute;
  background-color: #999999;
  color: #fff;
  padding: 5px;
  border-radius: 4px;
  z-index: 1;
  display: none;
  white-space: nowrap;
  top: 50%;
  left: calc(100% + 10px); /* Adjust the offset as needed */
  transform: translateY(-50%);
}

.tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-style: solid;
  border-width: 5px 5px 5px 0; /* Pointing to the right */
  border-color: transparent #999999 transparent transparent;
  top: 50%;
  left: -5px; /* Adjust the offset to place the arrow on the left */
  transform: translateY(-50%);
}

.custom-tooltip:hover .tooltip {
  display: block;
}
.tooltip-content {
  overflow-wrap: break-word; /* Use overflow-wrap for text wrapping */
}
</style>